/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramTransactionsUserControllerCheckStatusQueryResponse,
  TelegramTransactionsUserControllerCheckStatusQueryParams,
  TelegramTransactionsUserControllerCheckStatus401,
} from '../types/TelegramTransactionsUserControllerCheckStatus.ts';

function getTelegramTransactionsUserCheckStatusUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/transactions/check-status` as const };
  return res;
}

/**
 * {@link /api/user/telegram/transactions/check-status}
 */
export async function telegramTransactionsUserCheckStatus(
  params: TelegramTransactionsUserControllerCheckStatusQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramTransactionsUserControllerCheckStatusQueryResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerCheckStatus401>,
    unknown
  >({ method: 'GET', url: getTelegramTransactionsUserCheckStatusUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
